import { TJsonQuery } from '../../../packages/JsonQuery';
import { TLocation } from 'shared/types/location';
import { ISearchMeta } from 'shared/types/searchMeta';

export const ADVANCED_FILTERS_UPDATED_EVENT = 'advancedFilters:updated';

interface IFiltersUpdatedEventDetail {
  jsonQuery: TJsonQuery;
  searchMeta: ISearchMeta;
  location: TLocation;
}

export const dispatchAdvancedFiltersEvent = () => {
  dispatchEvent(new CustomEvent<IFiltersUpdatedEventDetail>(ADVANCED_FILTERS_UPDATED_EVENT));
};
